/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EmployeeFiveStarScore = {
    properties: {
        score: {
    type: 'number',
    isRequired: true,
},
        total: {
    type: 'number',
    isRequired: true,
},
    },
};